import { DIMENSION_TITLES } from './analytics'
import type { TranslationKeys } from '~/plugins/i18n'
import { NormalizedFieldEntry, SourceValueDimension } from '~/types/sourceValue'

export const NORMALIZED_FIELD_DEFINITION: {
  [key in NormalizedFieldEntry]?: {
    definition: TranslationKeys
  }
} = {
  [NormalizedFieldEntry.ABSENTEEISM_CATEGORY__IS_PLANNED]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.ABSENTEEISM_CATEGORY__IS_PLANNED}`
  },
  [NormalizedFieldEntry.ABSENTEEISM_TYPE__IS_PLANNED]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.ABSENTEEISM_TYPE__IS_PLANNED}`
  },
  [NormalizedFieldEntry.ABSENTEEISM_CATEGORY__IS_PLANNED_IN_EGAPRO_INDEX]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.ABSENTEEISM_CATEGORY__IS_PLANNED_IN_EGAPRO_INDEX}`
  },
  [NormalizedFieldEntry.ABSENTEEISM_CATEGORY__MATERNITY_TYPE_IN_EGAPRO_INDEX]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.ABSENTEEISM_CATEGORY__MATERNITY_TYPE_IN_EGAPRO_INDEX}`
  },
  [NormalizedFieldEntry.ABSENTEEISM_CATEGORY__IS_REAL]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.ABSENTEEISM_CATEGORY__IS_REAL}`
  },
  [NormalizedFieldEntry.ABSENTEEISM_CATEGORY__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.ABSENTEEISM_CATEGORY__TYPE}`
  },
  [NormalizedFieldEntry.MOBILITY_CATEGORY__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.MOBILITY_CATEGORY__TYPE}`
  },
  [NormalizedFieldEntry.DEPARTURE_REASON_TYPE__IS_REGRETTED]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.DEPARTURE_REASON_TYPE__IS_REGRETTED}`
  },
  [NormalizedFieldEntry.DEPARTURE_REASON_CATEGORY__IS_REGRETTED]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.DEPARTURE_REASON_CATEGORY__IS_REGRETTED}`
  },
  [NormalizedFieldEntry.DEPARTURE_REASON_CATEGORY__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.DEPARTURE_REASON_CATEGORY__TYPE}`
  },
  [NormalizedFieldEntry.PROFESSIONAL_CATEGORY__TYPE_IN_EGAPRO_INDEX]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.PROFESSIONAL_CATEGORY__TYPE_IN_EGAPRO_INDEX}`
  },
  [NormalizedFieldEntry.EMPLOYMENT_CATEGORY__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.EMPLOYMENT_CATEGORY__TYPE}`
  },
  [NormalizedFieldEntry.SALARY_CATEGORY__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.SALARY_CATEGORY__TYPE}`
  },
  [NormalizedFieldEntry.PAYROLL_CATEGORY__IS_IN_EGAPRO_INDEX]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.PAYROLL_CATEGORY__IS_IN_EGAPRO_INDEX}`
  },
  [NormalizedFieldEntry.PAYROLL_CATEGORY__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.PAYROLL_CATEGORY__TYPE}`
  },
  [NormalizedFieldEntry.HIRING_TYPE__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.HIRING_TYPE__TYPE}`
  },
  [NormalizedFieldEntry.RECRUITMENT_REJECTION_CATEGORY__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.RECRUITMENT_REJECTION_CATEGORY__TYPE}`
  },
  [NormalizedFieldEntry.RECRUITMENT_STAGE__IS_REJECTED]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.RECRUITMENT_STAGE__IS_REJECTED}`
  },
  [NormalizedFieldEntry.RECRUITMENT_STAGE__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.RECRUITMENT_STAGE__TYPE}`
  },
  [NormalizedFieldEntry.JOB_STATUS__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.JOB_STATUS__TYPE}`
  },
  [NormalizedFieldEntry.REMOTE_STATUS__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.REMOTE_STATUS__TYPE}`
  },
  [NormalizedFieldEntry.MANAGEMENT_CATEGORY__IS_MANAGER]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.MANAGEMENT_CATEGORY__IS_MANAGER}`
  },
  [NormalizedFieldEntry.HIRING_SOURCE__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.HIRING_SOURCE__TYPE}`
  },
  [NormalizedFieldEntry.NATIONALITY__TYPE]: {
    definition: `settings.dataNormalization.module.normalizationFieldDefinitions.${NormalizedFieldEntry.NATIONALITY__TYPE}`
  }
}

export const DIMENSION_TITLE_BY_SOURCE_VALUE_DIMENSION: {
  [key in SourceValueDimension]?: DIMENSION_TITLES
} = {
  [SourceValueDimension.SUBORGANIZATION]:
    DIMENSION_TITLES.EMPLOYEE_SUBORGANIZATION,
  [SourceValueDimension.DEPARTMENT]: DIMENSION_TITLES.EMPLOYEE_DEPARTMENT,
  [SourceValueDimension.GROUP_1]: DIMENSION_TITLES.EMPLOYEE_GROUP_1,
  [SourceValueDimension.GROUP_2]: DIMENSION_TITLES.EMPLOYEE_GROUP_2,
  [SourceValueDimension.GROUP_3]: DIMENSION_TITLES.EMPLOYEE_GROUP_3,
  [SourceValueDimension.GROUP_4]: DIMENSION_TITLES.EMPLOYEE_GROUP_4,
  [SourceValueDimension.GROUP_5]: DIMENSION_TITLES.EMPLOYEE_GROUP_5,
  [SourceValueDimension.GROUP_6]: DIMENSION_TITLES.EMPLOYEE_GROUP_6,
  [SourceValueDimension.GROUP_7]: DIMENSION_TITLES.EMPLOYEE_GROUP_7,
  [SourceValueDimension.LOCATION_OFFICE]:
    DIMENSION_TITLES.EMPLOYEE_LOCATION_OFFICE,
  [SourceValueDimension.LOCATION_REMOTE]:
    DIMENSION_TITLES.EMPLOYEE_LOCATION_REMOTE,
  [SourceValueDimension.LOCATION_1]: DIMENSION_TITLES.EMPLOYEE_LOCATION_1,
  [SourceValueDimension.LOCATION_2]: DIMENSION_TITLES.EMPLOYEE_LOCATION_2,
  [SourceValueDimension.LOCATION_3]: DIMENSION_TITLES.EMPLOYEE_LOCATION_3,
  [SourceValueDimension.CAREER_STAGE]: DIMENSION_TITLES.EMPLOYEE_CAREER_LEVEL,
  [SourceValueDimension.SUB_CAREER_STAGE]:
    DIMENSION_TITLES.EMPLOYEE_CAREER_SUB_LEVEL,
  [SourceValueDimension.JOB_LOCATION_1]: DIMENSION_TITLES.JOB_LOCATION_1
}
